import findAssociationDefinitionFromSpec from 'automation-ui-associations/utils/findAssociationDefinitionFromSpec';
export default function findAssociationObjectTypeIdFromSpec(associationSpec, associationDefinitionsQuery) {
  const definition = findAssociationDefinitionFromSpec(associationSpec, associationDefinitionsQuery);
  return definition && definition.toObjectTypeId;
}